import React from 'react';
import Spinner from '../spinner';

import './loader.css';

const Loader = () => (
  <div className="loader-container">
    Loading
    <Spinner isLoading />
  </div>
);

export default Loader;
